// Auto-generated normalizer for table: ExamenPreguntaVerdaderoFalso
export function examenPreguntaVerdaderoFalsoNormalize(row) {
  return {
    idExamenRespuestaVF: row.idExamenRespuestaVerdaderoFalso ?? row.IdExamenRespuestaVerdaderoFalso ?? row.idExamenRespuestaVF ?? row.IdExamenRespuestaVF ?? 0,
    idExamenPregunta: row.idExamenRespuesta ?? row.IdExamenRespuesta ?? row.idExamenPregunta ?? row.IdExamenPregunta ?? 0,
    respuestaCorrecta: row.respuesta ?? row.Respuesta ?? row.respuestaCorrecta ?? row.RespuestaCorrecta ?? false,
    activo: row.activo ?? row.Activo ?? true,
  };
}
